import './data/questionsData.js';

 

// src/main.js

// --- CSS IMPORTS (Vite Bundling) ---

import './assets/css/variables.css';

import './assets/css/base.css';

import './assets/css/animations.css';

import './assets/css/layout.css';

import './assets/css/components.css';

import './assets/css/screens.css';

import './assets/wr_styles.css';

import './assets/css/honeycomb.css';

import './assets/css/components/bottom-nav.css';

import './assets/css/mythology.css';

import './assets/css/screens/categories-dropdown.css';

import './assets/css/etkinlik-kitap.css';

import './assets/css/kanit-temelli.css';

import './assets/css/mobile-performance.css';

import './assets/css/components/radio_widget.css';



// --- IMPORT CORE MODULES ---

import './utils/DebugConsole.js'; // [DEBUG] On-screen Console

import './utils/security.js'; // [SECURITY] Sanitization

import './utils/audioManager.js';

import './utils/helpers.js';

import './utils/AccessibilityManager.js'; // [A11Y] Accessibility Manager

import './utils/MobileManager.js'; // [MOBILE] Manager

import './core/state.js';

import './ui/Router.js';

import './ui/SettingsManager.js';

import './ui/navigation.js';

import './ui/RadioManager.js';

import './components/common/RadioWidget.js';

import './core/multiplayer.js';



// --- IMPORT ONLINE MANAGERS ---

import './core/online/ConnectionHandler.js';

import './core/online/NotificationManager.js';

import './core/online/StatsManager.js';

import './data/history_data.js';

import './components/common/CsServerWidget.js';

import './components/common/HistoryWidget.js';

import './components/common/SidebarManager.js';

import './components/common/AtaturkCornerWidget.js';



import './components/common/MusicWidget.js';

import './core/online/LobbyManager.js';

import './core/online/OnlineGameUI.js';

import './core/online/ChatManager.js';

import './core/online/AuthManager.js';

import './core/online/MatchmakingManager.js';



// --- IMPORT COMPONENTS & GAME LOGIC ---

import './components/modals/SuccessModal.js';

import './components/modals/AuthModal.js';

import './components/modals/ProfileModal.js';

import './core/online_manager.js';

import './core/game/QuestionManager.js';

import './core/game/GameUI.js';

import './core/TeableQuestionService.js';

import './core/game.js';

import './features/wheel.js';







// --- UI LAYOUT ---

import { renderLayout } from './layout.js';



// --- DATA SCIRPTS (Ensuring they are loaded) ---

// [REMOVED] Local question files are no longer used. Data is fetched from API.





/**

 * GLOBAL EVENT DELEGATION CONTROLLER

 * Tüm buton tıklamalarını tek bir yerden yönetir.

 * Dinamik olarak eklenen/silinen DOM elemanları için en güvenli yöntemdir.

 */

function initGlobalEventListeners() {

    console.log("Main.js: Global Event Listeners Initialized");



    document.addEventListener('mouseover', (e) => {

        const target = e.target.closest('.category-btn, #week-btn, #gaddar-cat-btn, #wheel-btn, #solve-today-btn, .special-gundem-btn, #online-btn, #show-create-panel-btn, #show-join-panel-btn, #show-competition-btn');

        if (target) {

            if (window.audio && window.audio.playSound) {

                // If it's a category-btn, use 'categories' sound, otherwise 'hover_mode'

                const sound = target.classList.contains('category-btn') ? 'categories' : 'hover_mode';

                window.audio.playSound(sound);

            }

        }

    });



    document.addEventListener('click', async (e) => {

        const target = e.target;

        console.log("Global Click:", target.tagName, target.className, target.id);



        // --- 1. KATEGORİ MENÜSÜ AÇMA/KAPAMA ---

        const toggleBtn = target.closest('#toggle-cats-btn');

        if (toggleBtn) {

            const container = document.getElementById('academic-categories-container');

            if (container) {

                window.scrollTo({ top: 0, behavior: 'smooth' });

                container.classList.remove('hidden');

            }

            return;

        }



        const closeCatsBtn = target.closest('#close-cats-btn');

        if (closeCatsBtn) {

            const container = document.getElementById('academic-categories-container');

            if (container) {

                container.classList.add('hidden');

                // Eğer geri dönülüyorsa main menüye dön

                ui.showScreen('category-screen');
            setTimeout(startAppScreenshotsSlider, 100);

            }

            return;

        }



        // Modal Dışına Tıklama

        if (target.id === 'academic-categories-container') {

            target.classList.add('hidden');

            return;

        }



        // --- 2. KATEGORİ SEÇİMİ (Petek Menü) ---

        const categoryBtn = target.closest('.category-btn');

        if (categoryBtn) {

            // Ses Kilidi Aç

            if (window.audio && window.audio.unlockAudio) window.audio.unlockAudio();

            if (window.audio && window.audio.playSound) window.audio.playSound('buttons');



            const category = categoryBtn.dataset.category;

            state.currentCategory = category;



            // Modal'ı kapat

            const container = document.getElementById('academic-categories-container');

            if (container) container.classList.add('hidden');



            // Yönlendirme

            if (category === 'gundem') {

                ui.showScreen('gundem-screen');

            } else if (category === 'mythology') {

                ui.showScreen('mythology-screen');

            } else {

                state.currentDifficulty = 'mixed';

                ui.showScreen('mode-screen');

            }

            return;

        }



        // --- 3. HAFTANIN SORULARI ---

        const weekBtn = target.closest('#week-btn');

        if (weekBtn) {

            if (window.audio && window.audio.playSound) window.audio.playSound('buttons');

            handleWeekQuestions(weekBtn);

            return;

        }



        // --- 3.1. GADDARI TANI ---

        const gaddarBtn = target.closest('#gaddar-cat-btn');

        if (gaddarBtn) {

            if (window.audio && window.audio.playSound) window.audio.playSound('buttons');

            handleGaddarQuestions(gaddarBtn);

            return;

        }



        // --- 3.5. ŞANS ÇARKI ---

        const wheelBtn = target.closest('#wheel-btn');

        if (wheelBtn) {

            if (window.audio && window.audio.unlockAudio) window.audio.unlockAudio();

            if (window.audio && window.audio.playSound) window.audio.playSound('buttons');

            if (window.wheel && window.wheel.openWheelScreen) {

                window.wheel.openWheelScreen();

            }

            return;

        }



        // --- 3.6. TARİHTE BUGÜN (Günün Sorusu) ---

        const historyBtn = target.closest('#solve-today-btn');

        if (historyBtn) {

            if (window.audio && window.audio.playSound) window.audio.playSound('history_today');

            handleHistoryQuiz(historyBtn);

            return;

        }



        // [FIX] Gundem Button Handler (Special Button)

        const specialGundemBtn = target.closest('.special-gundem-btn');

        if (specialGundemBtn) {

            if (window.audio && window.audio.unlockAudio) window.audio.unlockAudio();

            if (window.audio && window.audio.playSound) window.audio.playSound('buttons');

            state.currentCategory = 'gundem';

            ui.showScreen('gundem-screen');

            return;

        }



        // [FIX] Global Back Button Handler

        const backBtn = target.closest('#back-btn');

        if (backBtn) {

            // [MITOLOJI FIX] Mitoloji modundaysak, oyun ekranından çıkınca Mitoloji menüsüne dön

            if (state.currentCategory === 'mythology') {

                // Eğer oyun ekranındaysak

                const gameScreen = document.getElementById('game-screen');

                if (gameScreen && gameScreen.classList.contains('active')) {

                    // Oyunu durdur (Timer vs)

                    if (window.game && window.game.abortGame) window.game.abortGame();

                    ui.showScreen('mythology-screen');

                    return;

                }

            }



            if (window.audio && window.audio.playSound) {

                window.audio.playSound('back');

            }



            if (window.Router && window.Router.goBack) {

                window.Router.goBack();

            } else {

                console.warn("Router.goBack not found fallback to history");

                window.history.back();

            }

            return;

        }



        // --- 4. GÜNDEM ALT SEÇİM (TR / DÜNYA) ---

        const gundemBtn = target.closest('.gundem-sub-btn');

        if (gundemBtn) {

            if (window.audio && window.audio.playSound) window.audio.playSound('buttons');

            const subType = gundemBtn.dataset.sub;

            state.currentDifficulty = subType;

            state.currentCategory = 'gundem';

            state.isTimedMode = false;



            // Gündem soruları API'den çekilir

            (async () => {

                let questions = [];

                if (window.TeableQuestionService) {

                    try {

                        questions = await window.TeableQuestionService.fetchGundemQuestions(subType);

                    } catch (e) {

                        console.warn('[Gündem] API hatası:', e);

                    }

                }

                if (questions && questions.length > 0) {

                    // Rastgele 10 tane seç

                    const shuffled = window.utils ? window.utils.shuffleArray([...questions]) : questions;

                    game.startCustomGame(shuffled.slice(0, 10), 'gundem');

                } else {

                    // Fallback: eski yöntem

                    await game.startGame();

                }

            })();

            return;

        }



        // --- 5. ZORLUK SEÇİMİ ---

        const diffBtn = target.closest('.difficulty-btn');

        if (diffBtn) {

            if (window.audio && window.audio.playSound) window.audio.playSound('buttons');

            if (window.audio && window.audio.playSound) window.audio.playSound('continue'); // [KEEP] Previous sound if any, but buttons is requested

            state.currentDifficulty = diffBtn.dataset.difficulty;

            ui.showScreen('mode-screen');

            return;

        }



        // --- 6. MOD SEÇİMİ (Süreli / Süresiz) ---

        const modeBtn = target.closest('.mode-btn');

        if (modeBtn) {

            const mode = modeBtn.dataset.mode;

            if (mode === 'sureli') {

                state.isTimedMode = true;

                const modal = document.getElementById('time-selection-modal');

                if (modal) {

                    modal.classList.remove('hidden');

                    modal.classList.add('flex');

                }

            } else {

                state.isTimedMode = false;

                await game.startGame();

            }

            return;

        }



        // --- 7. SÜRE SEÇİMİ (Modal İçi) ---

        const timeBtn = target.closest('.time-btn');

        if (timeBtn) {

            const time = parseInt(timeBtn.dataset.time);

            state.timePerQuestion = time;

            state.isTimedMode = true;



            if (window.audio) {

                window.audio.playSound('timer_selected');

                window.audio.playSound('continue');

            }



            const modal = document.getElementById('time-selection-modal');

            if (modal) {

                modal.classList.add('hidden');

                modal.classList.remove('flex');

            }

            await game.startGame();

            return;

        }



        // Süre Modal Kapatma

        if (target.closest('#close-time-modal-btn')) {

            const modal = document.getElementById('time-selection-modal');

            if (modal) {

                modal.classList.add('hidden');

                modal.classList.remove('flex');

            }

            return;

        }



        // --- 8. GLOBAL BUTONLAR ---

        // Başla Butonu (Intro)

        if (target.closest('#start-btn')) {

            if (window.audio) {

                window.audio.unlockAudio();

                window.audio.playSound('continue');

                // Removed automatic playMusic to respect "Default Off" requirement

            }

            if (window.AccessibilityManager) {

                window.AccessibilityManager.announce("Kategori seçim ekranına geçiliyor", "assertive");

            }

            ui.showScreen('category-screen');
            setTimeout(startAppScreenshotsSlider, 100);

            return;

        }



        // Tekrar Oyna

        if (target.closest('#restart-btn')) {

            if (state.currentCategory === 'custom_gaddar' || state.currentCategory === 'custom_week' || state.currentCategory === 'history_today') {

                ui.showScreen('category-screen');
            setTimeout(startAppScreenshotsSlider, 100);

            } else if (state.currentCategory === 'gundem') {

                ui.showScreen('gundem-screen');

            } else if (state.currentCategory === 'mythology') {

                ui.showScreen('mythology-screen');

            } else {

                ui.showScreen('mode-screen');

            }

            return;

        }







        // --- 9. MİTOLOJİ HANDLERS [NEW] ---



        // Ana Menü Butonu

        const mythBtn = target.closest('#myth-btn');

        if (mythBtn) {

            ui.showScreen('mythology-screen');

            return;

        }



        // Alt Kategori Seçimi

        const mythCard = target.closest('.myth-card');

        if (mythCard) {

            if (window.audio && window.audio.unlockAudio) window.audio.unlockAudio();

            if (window.audio && window.audio.playSound) window.audio.playSound('buttons');



            const subCat = mythCard.dataset.sub; // "Türk Mitolojisi", "Yunan Mitolojisi" etc.

            const catName = mythCard.querySelector('.myth-title').innerText;



            // Visual Feedback

            const originalOpacity = mythCard.style.opacity;

            mythCard.style.opacity = '0.7';

            document.body.style.cursor = 'wait';



            // State Ayarla

            state.currentCategory = 'mythology';

            state.currentDifficulty = subCat;

            state.isTimedMode = false; // Süresiz



            // Fetch Questions

            (async () => {

                try {

                    let questions = [];

                    if (window.TeableQuestionService && window.TeableQuestionService.fetchMythologyQuestions) {

                        questions = await window.TeableQuestionService.fetchMythologyQuestions(subCat);

                    } else {

                        throw new Error('TeableQuestionService module not found');

                    }



                    if (questions && questions.length > 0) {

                        // Shuffle questions

                        if (window.utils && window.utils.shuffleArray) {

                            questions = window.utils.shuffleArray(questions);

                        }



                        // [FIX] Limit to 10 questions and ensure randomization

                        const limitedQuestions = questions.slice(0, 10);



                        // Start Game

                        game.startCustomGame(limitedQuestions, 'mythology');

                    } else {

                        alert(`${subCat} için henüz soru eklenmemiş.`);

                    }

                } catch (e) {

                    console.error('Mitoloji soruları yüklenirken hata:', e);

                    alert('Sorular yüklenirken bir hata oluştu. Lütfen bağlantınızı kontrol edin.');

                } finally {

                    mythCard.style.opacity = originalOpacity || '1';

                    document.body.style.cursor = 'default';

                }

            })();



            return;

        }



        // Online Oyna Butonu (Layout içi) - Eğer HTML'de onclick yoksa burası yakalar

        if (target.closest('#online-btn')) {

            if (window.audio && window.audio.playSound) window.audio.playSound('buttons');

            if (window.handleOnlineClick) window.handleOnlineClick();

            return;

        }



        // --- NEW: MUSIC PLAYER CONTROLS ---

        if (target.closest('#music-shuffle-btn')) {

            if (window.audio) window.audio.toggleShuffle();

            if (window.audio && window.audio.playSound) window.audio.playSound('buttons');

            return;

        }



        if (target.closest('#music-play-pause-btn')) {

            if (window.audio) window.audio.togglePlayPause();

            if (window.audio && window.audio.playSound) window.audio.playSound('buttons');

            return;

        }



        if (target.closest('#music-next-btn')) {

            if (window.audio) window.audio.playNext();

            if (window.audio && window.audio.playSound) window.audio.playSound('buttons');

            return;

        }

    });



    // Handle progress slider separately (input event)

    const progressSlider = document.getElementById('music-progress-slider');

    if (progressSlider) {

        progressSlider.addEventListener('input', (e) => {

            if (window.audio) {

                window.audio.seek(e.target.value);

            }

            if (window.updateSliderProgress) {

                window.updateSliderProgress(e.target);

            }

        });

    }

}



/**

 * Gaddarı Tanı Sorularını Çeken Logic

 */

async function handleGaddarQuestions(btnElement) {

    if (!btnElement) return;

    const originalText = btnElement.innerHTML;

    btnElement.innerHTML = '<span class="icon">⏳</span> YÜKLENİYOR...';

    btnElement.style.pointerEvents = 'none';



    try {

        const questions = await window.TeableQuestionService.fetchGaddarQuestions();

        game.startCustomGame(questions, 'custom_gaddar');

    } catch (err) {

        console.error('Gaddar soruları yüklenirken hata:', err);

        alert('Sorular yüklenemedi! İnternet bağlantınızı kontrol edin.');

    } finally {

        btnElement.innerHTML = originalText;

        btnElement.style.pointerEvents = 'auto';

    }

}



/**

 * Haftanın Sorularını Çeken Logic

 */

async function handleWeekQuestions(btnElement) {

    if (!btnElement) return;

    const originalText = btnElement.innerHTML;

    btnElement.innerHTML = '<span class="icon">⏳</span> YÜKLENİYOR...';

    btnElement.style.pointerEvents = 'none';



    try {

        const questions = await window.TeableQuestionService.fetchWeeklyQuestions();

        game.startCustomGame(questions, 'custom_week');

    } catch (err) {

        console.error('Haftanın soruları yüklenirken hata:', err);

        alert('Sorular yüklenemedi! İnternet bağlantınızı kontrol edin.');

    } finally {

        btnElement.innerHTML = originalText;

        btnElement.style.pointerEvents = 'auto';

    }

}



/**

 * Tarihte Bugün Sorularını Çeken Logic

 */

async function handleHistoryQuiz(btnElement) {

    if (!window.HistoryWidget) return;



    // UI Feedback

    const originalText = btnElement.innerHTML;

    btnElement.innerHTML = '<span class="icon">⏳</span> YÜKLENİYOR...';

    btnElement.style.pointerEvents = 'none';



    try {

        // Önce Widget'taki (index'ten gelen) veriye bak

        const widgetData = window.HistoryWidget.getData();

        let questions = [];



        // Eğer widget verisinde hazır sorular varsa onları kullan (Gelecekte sunucu bunu da doldurabilir)

        if (widgetData && widgetData.questions && widgetData.questions.length > 0) {

            questions = widgetData.questions;

        } else {

            // Yoksa API'den çek (TeableService)

            // Tarih bilgisini al: MM-DD

            const date = new Date();

            const month = String(date.getMonth() + 1).padStart(2, '0');

            const day = String(date.getDate()).padStart(2, '0');

            const dateKey = `${month}-${day}`;



            console.log(`[History] Fetching questions for date: ${dateKey}`);



            if (window.TeableQuestionService) {

                try {

                    questions = await window.TeableQuestionService.fetchTarihteBugunQuestions();

                } catch (e) {

                    console.warn("[History] Service fetch failed:", e);

                }

            }

        }



        if (questions && questions.length > 0) {

            // Soruları formatla (ID çakışmasını önle)

            const formatted = questions.map((q, idx) => ({

                ...q,

                id: q.id || (80000 + idx)

            }));



            game.startCustomGame(formatted, 'history_today');

        } else {

            alert("Bugüne özel soru bulunamadı. Genel tarih soruları yükleniyor...");

            // Fallback: Normal Tarih oyunu başlat veya uyarı ver

            if (window.game) {

                state.currentCategory = 'tarih';

                await game.startGame();

            }

        }



    } catch (e) {

        console.error("History Quiz Error:", e);

        alert("Sorular yüklenirken hata oluştu.");

    } finally {

        btnElement.innerHTML = originalText;

        btnElement.style.pointerEvents = 'auto';

    }

}





// --- GLOBAL HANDLERS ---

window.handleOnlineClick = function () {

    console.log("Global Handler: Online Button Clicked");



    try {

        if (window.audio) {

            audio.unlockAudio();

            // Removed automatic playMusic

        }

    } catch (e) {

        console.error("Audio error:", e);

    }



    if (window.ui && window.ui.showScreen) {

        ui.showScreen('lobby-screen');

    }



    if (window.onlineManager) {

        window.onlineManager.init();

        window.onlineManager.switchPanel('main', false);

    }

};



window.safeInit = function (name, fn) {

    try {

        if (fn) fn();

        console.log(`Main.js: ${name} initialized.`);

    } catch (e) {

        console.error(`Main.js: ${name} Failed!`, e);

    }

}





window.initApp = async function () { // ASYNC YAPILDI

    console.log("Main.js: initApp started...");



    // [OPTIMIZATION] Device Detection & Class Injection

    try {

        window.MobileManager.init();

    } catch (e) {

        console.warn("MobileManager init failed:", e);

    }



    // [OPTIMIZATION] Render Layout first (prevents FOUC warning)

    try {

        renderLayout();

        console.log("Main.js: Layout Rendered.");

    } catch (e) {

        console.error("Main.js: Layout Render Failed!", e);

    }



    // UI/Router Init (CRITICAL)

    safeInit("Router/History", () => { if (window.ui && window.ui.initHistory) window.ui.initHistory(); });

    safeInit("Settings", () => { if (window.ui && window.ui.initSettings) window.ui.initSettings(); });

    safeInit("Radio", () => { if (window.RadioManager) window.RadioManager.init(); });

    safeInit("InlineRadio", () => { if (window.InlineRadioManager) window.InlineRadioManager.init(); });



    safeInit("Multiplayer", () => { if (window.multiplayer) multiplayer.init(); });

    safeInit("AuthManager", () => { if (window.AuthManager) window.AuthManager.init(); });

    safeInit("SidebarManager", () => { if (window.SidebarManager) window.SidebarManager.init(); });

    safeInit("MusicWidget", () => { if (window.MusicWidget) window.MusicWidget.init(); });

    safeInit("HistoryWidget", () => { if (window.HistoryWidget) window.HistoryWidget.init(); });

    safeInit("AccessibilityManager", () => { if (window.AccessibilityManager) window.AccessibilityManager.init(); });

    safeInit("AtaturkCornerWidget", () => { if (window.AtaturkCornerWidget) window.AtaturkCornerWidget.init(); });

    safeInit("CsServerWidget", () => { if (window.CsServerWidget) window.CsServerWidget.init(); });





    // Global Listenerları Tek Seferde Bağla

    try {

        initGlobalEventListeners();

        console.log("Main.js: Global Event Listeners Attached.");

    } catch (e) {

        console.error("Main.js: Global Event Listener Error:", e);

    }



    // [REMOVED] Redundant global click listener that was triggering unintended playback.

    // Audio context is now managed via specific button interactions.



    // [MOBILE OPTIMIZATION] Reliable CS Server Repositioning

    const moveCsWidget = () => {

        const csWidget = document.getElementById('cs-server-widget-container');

        const mainContainer = document.querySelector('.category-main-container');

        const leftCol = document.querySelector('.category-left-col .gaddar-widgets-wrapper');



        if (!csWidget || !mainContainer || !leftCol) return;



        if (window.innerWidth <= 768) {

            // Move to very bottom (after right-col)

            if (csWidget.parentElement !== mainContainer) {

                mainContainer.appendChild(csWidget);

            }

        } else {

            // Move back to left column under radio

            if (csWidget.parentElement !== leftCol) {

                leftCol.appendChild(csWidget);

            }

        }

    };

    window.addEventListener('resize', moveCsWidget);

    setInterval(moveCsWidget, 500); // Check dynamically



    console.log('Gaddar Bilgi Uygulaması Tamamen Başlatıldı (Event Delegation Active).');

};



// Start Immediately if loaded via module

if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', window.initApp);

} else {

    window.initApp();

}


import './assets/css/prestige_styles.css';




// --- GADDAR APP SCREENSHOTS SLIDER ENGINE ---
function startAppScreenshotsSlider() {
    console.log("Slider initialization triggered.");
    let activeIdx = 0;
    
    // Clear any previous slider interval
    if (window.appSliderInterval) {
        clearInterval(window.appSliderInterval);
        window.appSliderInterval = null;
    }
    
    const runSlider = () => {
        const slides = document.querySelectorAll('#app-phone-slider .slide');
        if (slides.length > 0) {
            // Hide all slides
            slides.forEach((slide, idx) => {
                slide.style.opacity = "0";
                slide.style.zIndex = "1";
            });
            // Show current active slide
            slides[activeIdx].style.opacity = "1";
            slides[activeIdx].style.zIndex = "5";
            
            // Advance index
            activeIdx = (activeIdx + 1) % slides.length;
        }
    };
    
    // Run immediately once
    runSlider();
    
    // Start looping every 5000ms (5 seconds)
    window.appSliderInterval = setInterval(runSlider, 5000);
}
window.startAppScreenshotsSlider = startAppScreenshotsSlider;
